import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9437110"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media-input" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_7 = { class: "btns" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认")

import { ref } from 'vue'
import { message } from 'ant-design-vue'

type TypeKey = 'video' | 'audio'
interface TabItem {
  key: TypeKey
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaInput',
  emits: ["insertVideo", "insertAudio", "close"],
  setup(__props, { emit }: { emit: ({
  (event: 'insertVideo', payload: string): void
  (event: 'insertAudio', payload: string): void
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {



const type = ref<TypeKey>('video')

const videoSrc = ref('https://mazwai.com/videvo_files/video/free/2019-01/small_watermarked/181004_04_Dolphins-Whale_06_preview.webm')
const audioSrc = ref('https://freesound.org/data/previews/614/614107_11861866-lq.mp3')

const tabs: TabItem[] = [
  { key: 'video', label: '视频' },
  { key: 'audio', label: '音频' },
]

const insertVideo = () => {
  if (!videoSrc.value) return message.error('请先输入正确的视频地址')
  emit('insertVideo', videoSrc.value)
}

const insertAudio = () => {
  if (!audioSrc.value) return message.error('请先输入正确的音频地址')
  emit('insertAudio', audioSrc.value)
}

return (_ctx: any,_cache: any) => {
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["tab", { 'active': type.value === tab.key }]),
          key: tab.key,
          onClick: ($event: any) => (type.value = tab.key)
        }, _toDisplayString(tab.label), 11, _hoisted_3)
      }), 64))
    ]),
    (type.value === 'video')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Input, {
            value: videoSrc.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((videoSrc).value = $event)),
            placeholder: "请输入视频地址，e.g. https://xxx.mp4"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
              style: {"margin-right":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (insertVideo()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    (type.value === 'audio')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Input, {
            value: audioSrc.value,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((audioSrc).value = $event)),
            placeholder: "请输入音频地址，e.g. https://xxx.mp3"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('close'))),
              style: {"margin-right":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (insertAudio()))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})